export default "__VITE_ASSET__DdDRbLwI__"